/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3NodeProvidersFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3NodeProvidersFormat = ClosedEnum<
  typeof GetApiV3NodeProvidersFormat
>;

export type GetApiV3NodeProvidersRequest = {
  format?: GetApiV3NodeProvidersFormat | undefined;
};

/** @internal */
export const GetApiV3NodeProvidersFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3NodeProvidersFormat
> = z.nativeEnum(GetApiV3NodeProvidersFormat);

/** @internal */
export const GetApiV3NodeProvidersFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3NodeProvidersFormat
> = GetApiV3NodeProvidersFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3NodeProvidersFormat$ {
  /** @deprecated use `GetApiV3NodeProvidersFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3NodeProvidersFormat$inboundSchema;
  /** @deprecated use `GetApiV3NodeProvidersFormat$outboundSchema` instead. */
  export const outboundSchema = GetApiV3NodeProvidersFormat$outboundSchema;
}

/** @internal */
export const GetApiV3NodeProvidersRequest$inboundSchema: z.ZodType<
  GetApiV3NodeProvidersRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  format: GetApiV3NodeProvidersFormat$inboundSchema.default("json"),
});

/** @internal */
export type GetApiV3NodeProvidersRequest$Outbound = {
  format: string;
};

/** @internal */
export const GetApiV3NodeProvidersRequest$outboundSchema: z.ZodType<
  GetApiV3NodeProvidersRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3NodeProvidersRequest
> = z.object({
  format: GetApiV3NodeProvidersFormat$outboundSchema.default("json"),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3NodeProvidersRequest$ {
  /** @deprecated use `GetApiV3NodeProvidersRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3NodeProvidersRequest$inboundSchema;
  /** @deprecated use `GetApiV3NodeProvidersRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3NodeProvidersRequest$outboundSchema;
  /** @deprecated use `GetApiV3NodeProvidersRequest$Outbound` instead. */
  export type Outbound = GetApiV3NodeProvidersRequest$Outbound;
}

export function getApiV3NodeProvidersRequestToJSON(
  getApiV3NodeProvidersRequest: GetApiV3NodeProvidersRequest,
): string {
  return JSON.stringify(
    GetApiV3NodeProvidersRequest$outboundSchema.parse(
      getApiV3NodeProvidersRequest,
    ),
  );
}

export function getApiV3NodeProvidersRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3NodeProvidersRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3NodeProvidersRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3NodeProvidersRequest' from JSON`,
  );
}
